import moment from 'moment-timezone';

export const getHeader = route => {
  const headerObj = {
    title: 'TakeMeTour Partner',
    activeKeys: []
  };
  if (route.indexOf('product') >= 0) {
    headerObj.activeKeys = ['product'];
    headerObj.title = 'Products';
  } else if (route.indexOf('transaction') >= 0) {
    headerObj.activeKeys = ['transaction'];
    headerObj.title = 'Your transactions';
  }
  return headerObj;
};

export const dateString = (date, type = 'all') => {
  let format;
  const dateFormat = 'D MMMM YYYY';
  const timeFormat = 'HH:mm';
  if (type === 'all') {
    format = `${dateFormat} ${timeFormat}`;
  } else if (type === 'date') {
    format = dateFormat;
  } else {
    format = timeFormat;
  }
  return moment(date).format(format);
};

export const mapStationName = (arr) => (arr && arr.length > 0 && arr[0].points && arr[0].points.map(station =>
  ({ label: `${station.type} - ${station.name}`, value: `${station.type} - ${station.name}` }))
) || [];



// WEBPACK FOOTER //
// ./src/utils/helpers.js